import {errorReporter} from 'hudl-base';
window.onerror = errorReporter.sendError;

import 'components/user-profile-page/user-profile-page';
